import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {};

export const mutations = {};

export const actions = {
  async acEvalFeatureFlag({}, { feature_key }) {
    const url = `/api/v1/feature-flag/eval`;
    try {
      const result = await api.get(`${url}?key=${feature_key}`);
      if (result?.data?.code === 0) {
        return {
          success: true,
          is_enabled: result?.data?.data != null,
          data: result?.data?.data,
          message: result?.data?.message,
        };
      } else {
        return {
          success: false,
          is_enabled: result?.data?.data != null,
          data: result?.data?.data,
          message: result?.data?.message,
        };
      }
    } catch (error) {
      return {
        success: false,
        is_enabled: null,
        data: null,
        message: error?.message,
      };
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
